import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=2da07aa0&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=2da07aa0&prod&lang=scss&scoped=true"
import style1 from "./Index.vue?vue&type=style&index=1&id=2da07aa0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da07aa0",
  null
  
)

export default component.exports